module.exports = __webpack_public_path__ + "static/service-center-51b353fd054698603006ced88a04b8b8.mp4";